import React, { useState } from "react";
import { LeadViewDetailsViewFullInfoProps } from "./lead-view-details-view-full-info.props";
import "./lead-view-details-view-full-info.scss";
import RenderCellContent from "../../../render-cell-content";
import { formatDateTime } from "../../../../../../utils/utils";
import ContactLink from "../../../../../../common/components/contact-link/contact-link";
import { useLogin } from "../../../../../../common/hooks/useUser";

const LeadViewDetailsViewFullInfo: React.FC<
  LeadViewDetailsViewFullInfoProps
> = (props: any) => {
  const {
    leadDetails,
    viewFullInfoOpen,
    setViewFullInfoOpen,
    permissions,
    isMobile,
  } = props;
  const [isViewOpen, setIsViewOpen] = useState<boolean>(true);
  const handleEditOpen = () => setViewFullInfoOpen(!viewFullInfoOpen);
  const { tenantDetails } = useLogin();
  const checkIsDisableEdit = () => {
    return tenantDetails?.tenantType === "Tenant" &&
      leadDetails?.lead_status === "Closed-Lost" &&
      leadDetails?.lead_source === "AFP"
      ? true
      : false;
  };
  console.log("leadDetails", leadDetails);
  return (
    <div className="lead-list-view-details-view-box-full-info">
      {!isMobile && (
        <div className="lead-list-view-details-view-box-full-info-header">
          <div>Additional Details</div>
          <div>
            {isViewOpen ? (
              <i
                className="fa fa-angle-down"
                onClick={() => {
                  setIsViewOpen(!isViewOpen);
                }}
              />
            ) : (
              <i
                className="fa fa-angle-up"
                onClick={() => {
                  setIsViewOpen(!isViewOpen);
                }}
              />
            )}
          </div>
        </div>
      )}
      {isViewOpen ? (
        <>
          <div className="lead-list-view-details-view-box-full-info-header-text-edit">
            <div className="lead-list-view-details-view-box-full-info-header-text">
              Lead Information
            </div>
            <div className="lead-list-view-details-view-box-full-info-header-edit">
              <button
                className="lead-list-view-edit-section"
                onClick={handleEditOpen}
                disabled={
                  checkIsDisableEdit() ||
                  !permissions?.canWrite ||
                  leadDetails?.lead_status === "Closed-Won"
                }
              >
                Edit
              </button>
            </div>
          </div>
          <div className="lead-list-view-details-view-box-full-info-data">
            <div className="lead-list-view-details-view-box-full-info-data-section">
              <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="lead-list-view-details-view-box-full-info-data-section-main">
                  Lead Value
                </div>
                <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                  {leadDetails?.lead_value
                    ? `$ ${leadDetails.lead_value}`
                    : "-"}
                </div>
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="lead-list-view-details-view-box-full-info-data-section-main">
                  Marital Status
                </div>
                <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                  {leadDetails?.marital_status || "-"}
                </div>
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="lead-list-view-details-view-box-full-info-data-section-main">
                  Secondary Email
                </div>
                <ContactLink
                  type="Email"
                  value={leadDetails?.secondary_email_address || "-"}
                  id={leadDetails?.id}
                  className="lead-list-view-details-view-box-full-info-data-section-sub"
                />
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="lead-list-view-details-view-box-full-info-data-section-main">
                  Fax
                </div>
                <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                  {leadDetails?.fax_number || "-"}
                </div>
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="lead-list-view-details-view-box-full-info-data-section-main">
                  Designation
                </div>
                <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                  <RenderCellContent text={leadDetails?.designation || "-"} />
                </div>
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="lead-list-view-details-view-box-full-info-data-section-main">
                  Modified By
                </div>
                <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                  {leadDetails?.modified_by || "-"}
                  <br />
                  {formatDateTime(leadDetails?.updated_at || "-", true)}
                </div>
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="lead-list-view-details-view-box-full-info-data-section-main">
                  Contact Person
                </div>
                <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                  {leadDetails?.contact_person || "-"}
                </div>
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="lead-list-view-details-view-box-full-info-data-section-main">
                  Contact Person Phone Number
                </div>
                <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                  <ContactLink
                    type="Phone"
                    value={leadDetails?.contact_person_phone_number || "-"}
                    id={leadDetails?.id}
                    className="lead-list-view-details-view-box-full-info-data-section-sub"
                  />
                </div>
              </div>
            </div>

            <div className="lead-list-view-details-view-box-full-info-data-section">
              <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="lead-list-view-details-view-box-full-info-data-section-main">
                  Age
                </div>
                <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                  {leadDetails?.age ? `${leadDetails?.age} Years` : "-"}
                </div>
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="lead-list-view-details-view-box-full-info-data-section-main">
                  Secondary Phone Number
                </div>
                <ContactLink
                  type="Phone"
                  value={leadDetails?.secondary_phone_number || "-"}
                  id={leadDetails?.id}
                  className="lead-list-view-details-view-box-full-info-data-section-sub"
                />
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="lead-list-view-details-view-box-full-info-data-section-main">
                  Website
                </div>
                <ContactLink
                  type="website"
                  value={leadDetails?.website_url || "-"}
                  id={leadDetails?.id}
                  className="lead-list-view-details-view-box-full-info-data-section-sub"
                />
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="lead-list-view-details-view-box-full-info-data-section-main">
                  Industry
                </div>
                <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                  {leadDetails?.industry || "-"}
                </div>
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="lead-list-view-details-view-box-full-info-data-section-main">
                  Social Lead ID
                </div>
                <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                  {leadDetails?.social_lead_id || "-"}
                </div>
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="lead-list-view-details-view-box-full-info-data-section-main">
                  Organisation
                </div>
                <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                  {leadDetails?.company || "-"}
                </div>
              </div>
              <div className="lead-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="lead-list-view-details-view-box-full-info-data-section-main">
                  Relationship
                </div>
                <div className="lead-list-view-details-view-box-full-info-data-section-sub">
                  {leadDetails?.relationship || "-"}
                </div>
              </div>
            </div>
          </div>
          <div className="lead-list-view-details-view-box-full-info-header-text">
            Description
          </div>
          <div className="lead-list-view-details-view-box-full-info-description-box description-box-container">
            {leadDetails?.description || "-"}
          </div>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default LeadViewDetailsViewFullInfo;
